<template>
    <div>
        <header-admin-pages
            title="Фомирование общественных советов"
            :counter="getData.length"
            :button="headerButton"/>
            <table>
                <tr>
                    <td>Заголовок</td>
                    <td>Описание</td>
                    <td>Дата</td>
                    <td class="drop-icon"></td>
                </tr>
                <tr v-for="(item, i) of getData" :key="'item'+i">
                    <td>{{ item.title }}</td>
                    <td v-html="item.description"></td>
                    <td>{{ item.date }}</td>
                    <td class="drop-icon">
                    <drop-list @clickItem="clickItem"
                                :id-item="item.id"
                                :edit-link="`formation_councils/${item.id}/edit`"/>
                    </td>
                </tr>
        </table>
    </div>
</template>
<script>
import HeaderAdminPages from '@/components/Admin/HeaderAdminPages'
import DropList from '@/components/Admin/DropList'
export default {
  name: 'FormationCouncils',

  data () {
    return {
      show: false,
      indexElement: 0,
      headerButton: {
        title: 'Добавить общественный совет',
        link: '/admin/formation_councils/create'
      }
    }
  },

  created () {
    this.$store.dispatch('setFormationPublicCouncilsAll')
  },

  methods: {
    clickItem (value) {
      if (value.value === 'del') {
        const consent = confirm('Вы уверены, чтобы хотите удалить общественный совет?')
        if (consent) {
          this.$store.dispatch('deleteFormationPC', value.id)
        } else {
          this.$noty.warning('Удаление отменено')
        }
      }
    }
  },

  computed: {
    getData () {
      return this.$store.getters.getFormationPublicCouncilsAll
    }
  },
  components: {
    HeaderAdminPages,
    DropList
  }
}
</script>
<style lang="scss" scoped>

.accordion-block {
    border: .06rem solid #E5E8EE;
    border-radius: 0.5rem;
    margin-bottom: 1.875rem;
    font-size: .875rem;
    line-height: 1.57;

    &.active {
      box-shadow: 0 .94rem 1.56rem rgba(189, 205, 221, 0.35);
    }

    header {
      color: #1F3245;
      font-weight: 600;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 1.25rem 1.875rem;

      & p { margin-right: 5rem; }
      & i {
        border: .1875rem solid #9D9D9D;
        border-width: 0 .1875rem .1875rem 0;
        border-radius: .0625rem;
        display: inline-block;
        padding: .1875rem;
        transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
        margin-bottom: .0625rem;
      }
      .active {
        transform: rotate(-135deg);
        -webkit-transform: rotate(-135deg);
      }
    }
  }
.content-sb{
    margin-bottom: 2rem;
}
.accordion-block__body{
    padding: 0 1.875rem;
}
  table{
    margin-top: 1rem;
    border-spacing: 0;
    border-collapse: collapse;

    tr{
      padding: 0;
      border-bottom: 1px solid #D5D6D9;

      td {
        max-width: 23%;
        font-size: .812rem;
        line-height: 154%;
        color: #1F3245;
        padding: 1.375rem 1.375rem 1.375rem 0;
        a {
          color: #246CB7;
        }
        img {
          cursor: pointer;
          width: 1.5rem;
          height: 1.5rem;
          object-fit: contain;
          object-position: center;
        }
      }
      &:first-of-type td{
        padding: 1rem 0;
        color: #5E686C;
      }
    }
  }
table:last-child tr{
    border-bottom: 0;
}
  //
@media screen and (max-width: 768px){
}
@media screen and (max-width: 420px){
  .accordion-block{
    header{
      padding: 1.25rem 1.38rem;
      p{
        margin-right: .125rem;
      }
    }
  }
}
</style>
